import axios from 'axios';

const API_URL = 'https://qwikbistro.shop';
// const TOKEN = "ad269451f183b23a15385b4c00469e6e62daef98";
const TOKEN = process.env.REACT_APP_QWIK_BISTRO_API_TOKEN;

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Authorization': `Bearer ${TOKEN}`,
    'Content-Type': 'application/json',
  },
});

export const qwikBistroOrderApiService = {
  // Get all orders
  getAllOrders: async () => {
    try {
      const response = await axiosInstance.get('/order/');
      return response.data.sort((a, b) => b.id - a.id); // Latest first
    } catch (error) {
      console.error('Error fetching orders:', error);
      throw error;
    }
  },

  // Get single order
  getOrder: async (id) => {
    try {
      const response = await axiosInstance.get(`/order/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching order:', error);
      throw error;
    }
  },

  // Update order status
  updateOrderStatus: async (id, statusData) => {
    try {
      const response = await axiosInstance.patch(`/order/${id}`, statusData);
      return response.data;
    } catch (error) {
      console.error('Error updating order status:', error);
      throw error;
    }
  },

  // Delete order
  deleteOrder: async (id) => {
    try {
      await axiosInstance.delete(`/order/${id}`);
      return true;
    } catch (error) {
      console.error('Error deleting order:', error);
      throw error;
    }
  },

  // Create new order (if needed)
  createOrder: async (orderData) => {
    try {
      const response = await axiosInstance.post('/order', orderData);
      return response.data;
    } catch (error) {
      console.error('Error creating order:', error);
      throw error;
    }
  },
};